import useCurrencyFormatters from "@hooks/useCurrencyFormatters"

import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { TotalBadgeProps } from "./TotalBadge.types"

const icon = faIcon({ name: "money-bills", style: "regular" })

export default function TotalBadge(props: TotalBadgeProps) {
    const { value, size = "md", label = "Total" } = props

    const { formatCurrency } = useCurrencyFormatters()

    const formatted = formatCurrency(value)

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={`${label}\n${formatted}`}>
            {formatted}
        </Badge>
    )
}
